// extracted by mini-css-extract-plugin
export default {"list":"index_list_JdjrF","current":"index_current_vnG05"};